import { useState, useEffect } from "react";
import axios, { API } from "../../api";

export function VoicePickerModal({ onClose, isPremium, currentVoice, onVoiceSelect, onUpgrade }) {
  const [voices, setVoices] = useState([]);
  const [selected, setSelected] = useState(currentVoice || "nova");
  const [saving, setSaving] = useState(false);
  const [previewing, setPreviewing] = useState(null);

  useEffect(() => {
    axios.get(`${API}/voice/voices`)
      .then(r => setVoices(r.data.voices || []))
      .catch(e => console.error("voices error", e));
  }, []);

  const previewVoice = async (voiceId) => {
    if (!isPremium) return;
    setPreviewing(voiceId);
    try {
      const res = await axios.post(`${API}/voice/speak`,
        { text: "Hi, I'm Aura. I'm so glad we're talking like this.", voice: voiceId },
        { responseType: "blob" }
      );
      const url = URL.createObjectURL(res.data);
      const audio = new Audio(url);
      audio.onended = () => { URL.revokeObjectURL(url); setPreviewing(null); };
      audio.onerror = () => { setPreviewing(null); };
      await audio.play();
    } catch (e) {
      console.error("preview error", e);
      setPreviewing(null);
    }
  };

  const handleApply = async () => {
    if (!isPremium) { onUpgrade(); return; }
    setSaving(true);
    try {
      await axios.post(`${API}/user/preferences`, { preferred_voice: selected });
      onVoiceSelect(selected);
      onClose();
    } catch (e) {
      console.error("save voice error", e);
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="theme-picker-modal" onClick={(e) => e.stopPropagation()} data-testid="voice-picker-modal">
        <div className="journal-header">
          <h2>🎙️ Aura's Voice {!isPremium && <span className="premium-badge-small">PRO</span>}</h2>
          <button className="journal-close" onClick={onClose} data-testid="voice-close-btn">×</button>
        </div>
        <p className="journal-subtitle">Choose how Aura sounds when she speaks</p>

        {!isPremium && (
          <div className="theme-locked-banner">
            <span>💜 Voice is a Premium feature — $1.99/mo</span>
          </div>
        )}

        <div className="voices-list">
          {voices.map((v) => (
            <div
              key={v.id}
              className={`voice-row ${selected === v.id ? "selected" : ""}`}
              onClick={() => setSelected(v.id)}
              data-testid={`voice-${v.id}`}
            >
              <div className="voice-info">
                <strong>{v.name}</strong>
                <span>{v.description}</span>
              </div>
              <button
                className="voice-preview-btn"
                onClick={(e) => { e.stopPropagation(); previewVoice(v.id); }}
                disabled={!isPremium || previewing === v.id}
                data-testid={`voice-preview-${v.id}`}
              >
                {previewing === v.id ? "▶ Playing..." : "▶ Preview"}
              </button>
              {selected === v.id && <div className="theme-check">✓</div>}
            </div>
          ))}
        </div>

        <button
          className="init-btn"
          onClick={handleApply}
          disabled={saving}
          data-testid="apply-voice-btn"
        >
          {saving ? "Saving..." : isPremium ? "Apply Voice" : "💜 Unlock Voice"}
        </button>
      </div>
    </div>
  );
}
